import { useIsMobileScreen } from '@lib/utils/mediaQuery'

const useIsMobile = (): boolean => useIsMobileScreen(768)

export default useIsMobile
